export default "__VITE_ASSET__BkOBc6ls__"